module.exports = __webpack_public_path__ + "img/info.c016fd92.svg";